export default __webpack_public_path__ + "3c13d15f2ad3d6b41a316fa65cdd61f1.svg";